import { render } from "./CompanyCard.vue?vue&type=template&id=7508130f&scoped=true"
import script from "./CompanyCard.vue?vue&type=script&lang=js"
export * from "./CompanyCard.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7508130f"

export default script